export default "__VITE_ASSET__dcVhKnL9__"